import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { CTA, Icon, Modal, RadioButton, Text } from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import { AnswerWrapper, Legend, QuestionWrapper, Star, StarsWrapper, Textarea } from './style';
import { isValidForm, newForm } from '../../../../utils/form';
import { RegexpType, validator } from '../../../../utils/validator';
import {
  COURSE_DETAILS_GET,
  SURVEY_RESET,
  SURVEY_SEND_ANSWERS,
} from '../../../../app/redux/actions/coursedetails';

export const starsOptions = [
  {
    value: 1,
    label: 'Per niente soddisfatto',
  },
  {
    value: 2,
    label: 'Poco soddisfatto',
  },
  {
    value: 3,
    label: 'Normale',
  },
  {
    value: 4,
    label: 'Soddisfatto',
  },
  {
    value: 5,
    label: 'Molto soddisfatto',
  },
];

const initialForm = newForm([]);

export const ModalSurveyId = 'ModalSurvey';

const ModalSurvey = ({
  mediaIsPhone,
  isOpen,
  id,
  title,
  survey,
  modalClose,
  getCourseDetails,
  resetSurvey,
  sendSurveyAnswers,
}) => {
  const scrollableAreaRef = useRef(null);
  const [form, setForm] = useState(initialForm);

  useEffect(() => {
    if (!isOpen) {
      setForm(initialForm);
      resetSurvey();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  useEffect(() => {
    if (id) getCourseDetails(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleOnChange = (field = '', newValue) => {
    const { type } = form[field];
    setForm({
      ...form,
      [field]: {
        ...form[field],
        value: newValue,
        valid:
          typeof newValue !== 'object' ? validator(type, newValue, true) : true,
      },
    });
  };

  useEffect(() => {
    const newSurveyForm = { ...form };
    (survey?.data?.elements || []).forEach((s) => {
      newSurveyForm[`${s.answer_type}-${s.question_id}`] = {
        required: s?.answer_type === 'id' || s?.answer_type === 'rating',
        type: RegexpType.STRING,
        valid: true,
      };
    });
    setForm(newSurveyForm);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [survey]);

  const handleOnClick = (answers = {}) => {
    const body = [];
    Object.keys(answers).forEach((key) => {
      const [qType, qId] = key.split('-');
      const aValue = answers[key]?.value;
      const answer = {
        question_id: qId,
        answer_type: qType,
      };
      if (qType === 'free_text') {
        if (!aValue) return;
        answer.answer = aValue;
      } else if (qType === 'rating') {
        answer.rate = [aValue];
      } else {
        answer.answer_ids = [aValue];
      }
      body.push(answer);
    });
    sendSurveyAnswers(survey?.id, body, id);
  };

  if (!survey?.data?.elements) return null;

  let notRatingCounter = 0;

  return (
    <Modal
      modalId={ModalSurveyId}
      scrollableAreaRef={scrollableAreaRef}
      title={survey.title}
      paddingInline={32}
      isSurvey
      forceFullscreen={mediaIsPhone}
    >
      <ScrollableArea
        ref={scrollableAreaRef}
        style={{ maxWidth: '1049px' }}
      >
        <Text type="b2" mb={24} className="text-center">
          Questionario di valutazione del corso:
        </Text>
        <Text type="h2" mb={48} className="text-center">
          {title}
        </Text>
        {(survey?.data?.elements || []).map((s, i) => {
          if (s?.answer_type !== "rating") notRatingCounter += 1;
          return (
            <QuestionWrapper key={`question-${i}`} as={s?.answer_type === 'free_text' ? 'div' : 'fieldset'}>
              <Text
                tag={s?.answer_type === 'free_text' ? 'label' : 'legend'}
                htmlFor={`${s?.answer_type}-${s?.question_id}`}
                type="h2.5"
                mb={32}
                className={s?.required_answers > 0 ? 'mandatory' : s?.answer_type === 'rating' ? 'text-center mandatory' : ''}
              >
                {s?.answer_type !== "rating" ? `${notRatingCounter}. ` : ''}{s.question}
              </Text>
              <AnswerWrapper>
                {s?.answer_type === 'free_text' ? (
                  <Textarea
                    id={`${s?.answer_type}-${s?.question_id}`}
                    placeholder="Inserisci qui il tuo testo"
                    onChange={(e) =>
                      handleOnChange(
                        `${s?.answer_type}-${s?.question_id}`,
                        e?.target?.value
                      )
                    }
                  />
                ) : s?.answer_type === 'rating' ? (
                  <StarsWrapper>
                    {starsOptions.map((star, index) => (
                      <Star
                        key={`star-${index}`}
                        onClick={() =>
                          handleOnChange(
                            `${s?.answer_type}-${s?.question_id}`,
                            star.value
                          )
                        }
                        className={
                          star.value <=
                            form[`${s?.answer_type}-${s?.question_id}`]?.value
                            ? 'active'
                            : ''
                        }
                      >
                        <Icon type="star-01" size={25} />
                        <Text type="b3" className="star-text">
                          {star.label}
                        </Text>
                      </Star>
                    ))}
                  </StarsWrapper>
                ) : (
                  (s?.answers || []).map((a) => (
                    <RadioButton
                      key={`answer-${a?.id}`}
                      label={a.value}
                      onChange={() =>
                        handleOnChange(
                          `${s?.answer_type}-${s?.question_id}`,
                          a?.id
                        )
                      }
                      name={`${s?.answer_type}-${s?.question_id}`}
                      className="quiz"
                      checked={
                        form[`${s?.answer_type}-${s?.question_id}`]?.value ===
                        a?.id
                      }
                    />
                  ))
                )}
              </AnswerWrapper>
            </QuestionWrapper>
          );
        })}
        <Legend>
          <Text type="b3">* risposta obbligatoria</Text>
        </Legend>
      </ScrollableArea>
      <Footer>
        <CTA
          type="secondary"
          btnText="salta"
          onClick={modalClose}
        />
        <CTA
          type="primary"
          btnText="invia il questionario"
          onClick={() => {
            handleOnClick(form);
            modalClose();
          }}
          disabled={Object.keys(form)?.length === 0 || !isValidForm(form)}
        />
      </Footer>
    </Modal>
  );
};

ModalSurvey.propTypes = {
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state
  isOpen: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  survey: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  // dispatch
  modalClose: PropTypes.func.isRequired,
  getCourseDetails: PropTypes.func.isRequired,
  resetSurvey: PropTypes.func.isRequired,
  sendSurveyAnswers: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const {
        payload: { title, id },
        isOpen,
      } = state.app.modal;
      const { satisfaction_survey: survey } = state.coursedetails;
      return {
        isOpen,
        id,
        title,
        survey,
      };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      getCourseDetails: (id) =>
        dispatch({ type: COURSE_DETAILS_GET._REQUEST, id }),
      resetSurvey: () => dispatch({ type: SURVEY_RESET }),
      sendSurveyAnswers: (activity_id, body, course_id) =>
        dispatch({
          type: SURVEY_SEND_ANSWERS._REQUEST,
          activity_id,
          body,
          course_id,
        }),
    })
  ),
  withMediaQueries
)(ModalSurvey);
